import {useGetQuestionSampleSetDetailQuery} from '~/store/rtkQuery';

import {QuestionSampleSetQuestionData} from '../AiSupport.types';
import {useJsonDataFromStorage} from '../hooks';

export const useQuestionSampleSetDetail = ({id}: {id: string}) => {
  const {data, isLoading, error, refetch} = useGetQuestionSampleSetDetailQuery({
    id,
  });

  const {
    data: sampleData,
    error: fetchSampleError,
    fetchFileData,
  } = useJsonDataFromStorage<QuestionSampleSetQuestionData[]>({
    storageFilePath: data?.sample.data_file_path ?? '',
  });

  return {
    data,
    sampleData,
    isLoading,
    error: error || fetchSampleError,
    fetchData: refetch,
    fetchSampleData: fetchFileData,
  };
};
